<template>
  <v-toolbar dark
             :color="$root.themeColor"
             class="toolbar">
    <v-content>
      <v-row class="content">
        <v-btn class="btn-first"
               v-if="isLogin=='1'"
               @click="toggleNavigationBar">
          <v-icon>fa fa-server</v-icon>
        </v-btn>
        <router-link :to="{ name: 'Main' }">
          <img class="logo"
               src="@/assets/logo.png" />
        </router-link>

        <v-flex class="company-name">四川持恒空间科技有限公司</v-flex>

        <v-flex class="content">
          <v-bottom-navigation v-if="isLogin =='0'"
                               :value="toolbarValue"
                               class="navigation"
                               color="primary"
                               horizontal>
            <v-btn @click="$router.push({ name: 'Main' })">
              <span>首页</span>
            </v-btn>

            <v-btn @click="$router.push({ name: 'CompanyProfile' })">
              <span>公司简介</span>
            </v-btn>

            <v-btn @click="$router.push({ name: 'News' })">
              <span>新闻动态</span>
            </v-btn>

            <v-btn>
              <span @click="$router.push({ name: 'Product' })">产品介绍</span>
            </v-btn>

            <v-btn>
              <span @click="doContact">联系我们</span>
            </v-btn>
          </v-bottom-navigation>
        </v-flex>

        <v-spacer></v-spacer>

        <v-btn class="setting"
               @click="dialogSettings = true">
          <v-icon>fa fa-cog</v-icon>
        </v-btn>
      </v-row>

      <v-dialog v-model="dialogSettings"
                class="setting-dialog"
                width="400">
        <v-card>
          <v-card-title primary-title>设置</v-card-title>
          <!-- <v-btn @click="login"
                 class="login">
            登录
          </v-btn> -->
          <v-card-text>
            请选择您要更改的背景颜色
            <v-color-picker v-model="$root.themeColor"></v-color-picker>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-content>
  </v-toolbar>
</template>
<script>
export default {
  props: {
    toolbarValue: {
      type: Number,
    },
    isLogin: {
      type: String,
      default: "0"

    }
  },
  data () {
    return {
      rating: null,
      dialog: false,
      dialogSettings: false,
    }
  },

  computed: {},
  methods: {
    //滚动到底部
    doContact () {
      this.$emit('doContact')
    },
    //开关左侧导航栏
    toggleNavigationBar () {
      this.$emit('toggleNavigationBar')
    },
    login () {
      this.$router.push({ name: 'Login' })
    }
  },
}
</script>
<style scoped>
.toolbar,
.toolbar >>> .v-toolbar__content {
  min-height: 90px;
  white-space: initial;
}
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px !important;
}
.v-toolbar__content {
  height: 80px !important;
}
.logo {
  width: 80px;
  height: 80px;
}
.toolbar-menu-item {
  padding-left: 5px;
}
.setting {
  background: #66ccff !important;
  width: 40px !important;
  min-width: 40px !important;
}

.company-name {
  font-size: 25px;
  text-align: center;
  width: 500px;
  flex: none;
}
.navigation {
  background: inherit;
  border: 1px solid white;
  border-color: transparent;
  width: 600px;
  box-shadow: none;
  height: 80px;
}
.navigation >>> .v-btn {
  font-size: 20px;
  margin-left: 30px;
}
.setting-dialog {
  position: relative;
}
.login {
  position: absolute;
  right: 10px;
  bottom: 20px;
}
</style>
